/* eslint-disable complexity */

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getRgaAdditionalData,
    getRgaAdditionalDataType,
    getRgaAdditionalTestParameter,
    getRgaDetailAnalysisInfo,
    getRgaDetailConsignmentInfo,
    getRgaDetailDealerInfo,
    getRgaDetailQandA,
    postRgaAdditionalDataValuesAPI,
    postRgaAnalysisValuesAPI,
    postRgaConsignmentValuesAPI,
    postRgaDealerInfoValuesAPI
} from '../../shared/repositories';
import actions from '../../actions-list';
import {getFilesRga as getFileRepo} from '../../../product/shared/repositories';
import {getDefaultState as getRgaConsignmentDefaultState} from '../state/rga-consignment-details';
import {getDefaultState as getRgaDealerDefaultState} from '../state/rga-dealer-details';
import {getDefaultState as getRgaQandADefaultState} from '../state/rga-q-and-a';
import {routerActions} from 'react-router-redux';
import {successAlertBar} from '../../../shared/services/alert-bar';
import {translate} from '../../../shared/services/translation-service';

const buildRgaDetailsFileObject = rga => {

    const objectKey = `RGA${rga.rgaNumber}${rga.warrantyClaimNumber}`;
    const className = 'BUS2222';
    const classType = 'BO';

    return {
        className,
        classType,
        objectKey
    };

};

export const resetProperties = feature =>
    async dispatch => {

        if (feature === 'dealerData') {

            dispatch({
                rgaDealerDetails: getRgaDealerDefaultState(),
                type: actions.UPDATE_RGA_DEALER_DETAILS
            });

        }
        if (feature === 'consignment') {

            dispatch({
                rgaConsignmentDetails: getRgaConsignmentDefaultState(),
                type: actions.UPDATE_RGA_CONSIGNMENT_DETAILS
            });

        }
        if (feature === 'qanda') {

            dispatch({
                rgaDealerQuestionAns: getRgaQandADefaultState(),
                type: actions.UPDATE_RGA_Q_AND_A_DETAILS
            });

        }

    };
export const getRgaFiles = rga =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const fileDetails = buildRgaDetailsFileObject(rga);
            const files = await getFileRepo(fileDetails, rga);

            dispatch({
                files,
                type: actions.UPDATE_RGA_FILE_DETAILS
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const getRgaQandA = rga =>

        async dispatch => {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                const rgaDealerQuestionAns = await getRgaDetailQandA(rga);

                dispatch({
                    rgaDealerQuestionAns,
                    type: actions.UPDATE_RGA_Q_AND_A_DETAILS
                });

            } catch (error) {

            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        };

export const getRgaDealerInfo = rga =>

            async dispatch => {

                dispatch(busyCounter.increaseBusyCounter());

                try {

                    const rgaDealerDetails = await getRgaDetailDealerInfo(rga);

                    dispatch({
                        rgaDealerDetails,
                        type: actions.UPDATE_RGA_DEALER_DETAILS
                    });

                } catch (error) {

                } finally {

                    dispatch(busyCounter.decreaseBusyCounter());

                }

            };

export const getRgaConsignment = rga =>

                async dispatch => {

                    dispatch(busyCounter.increaseBusyCounter());

                    try {

                        const rgaConsignmentDetails = await getRgaDetailConsignmentInfo(rga);

                        dispatch({
                            rgaConsignmentDetails,
                            type: actions.UPDATE_RGA_CONSIGNMENT_DETAILS
                        });

                    } catch (error) {

                    } finally {

                        dispatch(busyCounter.decreaseBusyCounter());

                    }

                };

export const getRgaDetails = (rga, redirectAnalyst = true) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const rgaDetailsInfo = await getRgaDetailAnalysisInfo(rga);

            dispatch({
                rgaDetailsInfo,
                type: actions.UPDATE_RGA_DETAILS
            });

            if (redirectAnalyst) {

                dispatch(routerActions.push('/rga/recalled/returned-part?tab=analyst'));

            } else {

                dispatch(routerActions.push('/rga/recalled/returned-part?tab=attachment'));

            }

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

export const postRgaAnalysisValues = rga =>

        async dispatch => {

            dispatch(busyCounter.increaseBusyCounter());

            try {

                await postRgaAnalysisValuesAPI(rga);

                successAlertBar(translate('Analysis Values Saved Successfully'));

                dispatch(getRgaDetails(rga, true));

            } catch (error) {
            } finally {

                dispatch(busyCounter.decreaseBusyCounter());

            }

        };

export const postRgaDealerInfoValues = rga =>

            async dispatch => {

                dispatch(busyCounter.increaseBusyCounter());

                try {

                    await postRgaDealerInfoValuesAPI(rga);

                    successAlertBar(translate('Dealer Info Values Saved Successfully'));

                    dispatch(getRgaDealerInfo(rga));

                } catch (error) {
                } finally {

                    dispatch(busyCounter.decreaseBusyCounter());

                }

            };

export const postRgaConsignmentValues = rga =>

                async dispatch => {

                    dispatch(busyCounter.increaseBusyCounter());

                    try {

                        await postRgaConsignmentValuesAPI(rga);

                        successAlertBar(translate('Consignment Info Values Saved Successfully'));

                        dispatch(getRgaConsignment(rga));

                    } catch (error) {
                    } finally {

                        dispatch(busyCounter.decreaseBusyCounter());

                    }

                };

                /* Additional data action creators can be added here */

export const getAdditionalDataType = rgaUnit =>

                    async dispatch => {

                        dispatch(busyCounter.increaseBusyCounter());

                        try {

                            const rgaAdditionalDataType = await getRgaAdditionalDataType(rgaUnit);

                            dispatch({
                                rgaAdditionalDataType,
                                type: actions.UPDATE_RGA_ADDITIONAL_DATA_TYPE_DOMAIN
                            });

                        } catch (error) {

                        } finally {

                            dispatch(busyCounter.decreaseBusyCounter());

                        }

                    };

export const getAdditionalTestParameter = rgaUnit =>

                        async dispatch => {

                            dispatch(busyCounter.increaseBusyCounter());

                            try {

                                const rgaAdditionalDataTestParam = await getRgaAdditionalTestParameter(rgaUnit);

                                dispatch({
                                    rgaAdditionalDataTestParam,
                                    type: actions.UPDATE_RGA_ADDITIONAL_DATA_TEST_DOMAIN
                                });

                            } catch (error) {

                            } finally {

                                dispatch(busyCounter.decreaseBusyCounter());

                            }

                        };

export const getAdditionalData = (rganumber, rgaUnit) =>

                            async dispatch => {

                                dispatch(busyCounter.increaseBusyCounter());

                                try {

                                    const additionalDataInfo = await getRgaAdditionalData(rganumber, rgaUnit);

                                    dispatch({
                                        additionalDataInfo,
                                        type: actions.UPDATE_RGA_ADDITIONAL_DATA_INFO
                                    });

                                    if (additionalDataInfo.dataType && additionalDataInfo.dataType.key !== '') {

                                        dispatch({
                                            dataTypeFlag: true,
                                            type: actions.UPDATE_RGA_ADDITIONAL_DATA_INFO_FLAG
                                        });

                                    } else {

                                        dispatch({
                                            dataTypeFlag: false,
                                            type: actions.UPDATE_RGA_ADDITIONAL_DATA_INFO_FLAG
                                        });

                                    }

                                } catch (error) {

                                } finally {

                                    dispatch(busyCounter.decreaseBusyCounter());

                                }

                            };

export const postRgaAdditionalDataValues = (rgaAdditionalData, isUpdate) =>

                                async dispatch => {

                                    dispatch(busyCounter.increaseBusyCounter());

                                    try {

                                        await postRgaAdditionalDataValuesAPI(rgaAdditionalData, isUpdate);

                                        successAlertBar(translate('Additional Data Values Saved Successfully'));

                                        dispatch(getAdditionalData(rgaAdditionalData.rgaNumber, rgaAdditionalData.responsibleUnit));

                                    } catch (error) {
                                    } finally {

                                        dispatch(busyCounter.decreaseBusyCounter());

                                    }

                                };



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/action-creators/rga-details.js